export default class PetQuotation {
  name: string
  riskNumber: string

  constructor(data: any) {
    this.name = data.name
    this.riskNumber = data.riskNumber
  }
}
